<template>
    <div>
        <h1 style="font-size: 24px; color: black;">收入分布占比日报</h1>
        <el-card class="form-container" shadow="never">
            <el-form :inline="true" :model="queryData" size="small" label-width="140px">
                <el-form-item label="日期：">
                    <el-date-picker
                            v-model="queryData.timeDate"
                            type="daterange"
                            :clearable="false"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            value-format="yyyy-MM-dd">
                    </el-date-picker>&emsp;&emsp;
                </el-form-item>
                <el-form-item label=" " class="sub-sub10" >
                    <el-button type="primary" @click="query">查询</el-button>
                    <el-button class="std" type="primary"  @click="exportExcel" >导出</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <div style="margin-top: 20px">
            <el-table :data="dataList"
                      style="width: 100%"
                      border
                      :header-cell-style="{background:'#303133'}"
                      element-loading-text="拼命加载中"
                      element-loading-spinner="el-icon-loading"
                      element-loading-background="rgba(0, 0, 0, 0.8)"
                      v-loading="loading">
                <el-table-column label="项目" prop="appName" align="center"></el-table-column>
                <el-table-column label="日期" align="center">
                    <template slot-scope="scope" >
                        {{formatDate(scope.row.dt,"yyyy-MM-DD")}}
                    </template>
                </el-table-column>

                <el-table-column label="视频" align="center">
                    <el-table-column  label="收入占比">
                        <template  slot-scope="scope">
                            {{scope.row.videoIncomeRate==null?'0.00%':(scope.row.videoIncomeRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                </el-table-column>

                <el-table-column label="插屏" align="center">
                    <el-table-column  label="收入占比">
                        <template  slot-scope="scope">
                            {{scope.row.interstitialIncomeRate==null?'0.00%':(scope.row.interstitialIncomeRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                </el-table-column>

                <el-table-column label="信息流" align="center">
                    <el-table-column  label="收入占比">
                        <template  slot-scope="scope">
                            {{scope.row.flowIncomeRate==null?'0.00%':(scope.row.flowIncomeRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                </el-table-column>

                <el-table-column label="开屏" align="center">
                    <el-table-column  label="收入占比">
                        <template  slot-scope="scope">
                            {{scope.row.splashIncomeRate==null?'0.00%':(scope.row.splashIncomeRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                </el-table-column>

                <el-table-column label="视频" align="center">
                    <el-table-column  label="人均次数">
                        <template  slot-scope="scope">
                            {{scope.row.perVideoTimes==null?'0.00':scope.row.perVideoTimes.toFixed(2)}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="同比">
                        <template  slot-scope="scope">
                            {{scope.row.perVideoTimesSameRate==null?'0.00%':(scope.row.perVideoTimesSameRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="环比">
                        <template  slot-scope="scope">
                            {{scope.row.perVideoTimesCircleRate==null?'0.00%':(scope.row.perVideoTimesCircleRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="ecpm">
                        <template  slot-scope="scope">
                            {{scope.row.videoEcpm==null?'0.00':scope.row.videoEcpm.toFixed(2)}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="环比">
                        <template  slot-scope="scope">
                            {{scope.row.videoEcpmCircleRate==null?'0.00%':(scope.row.videoEcpmCircleRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="arpu">
                        <template  slot-scope="scope">
                            {{scope.row.videoArpu==null?'0.00':scope.row.videoArpu.toFixed(3)}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="收入">
                        <template  slot-scope="scope">
                            {{scope.row.videoRevenue==null?'0.00':scope.row.videoRevenue.toFixed(2)}}
                        </template>
                    </el-table-column>
                </el-table-column>

                <el-table-column label="插屏" align="center">
                    <el-table-column  label="人均次数">
                        <template  slot-scope="scope">
                            {{scope.row.perInterstitialTimes==null?'0.00':scope.row.perInterstitialTimes.toFixed(2)}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="同比">
                        <template  slot-scope="scope">
                            {{scope.row.perInterstitialTimesSameRate==null?'0.00%':(scope.row.perInterstitialTimesSameRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="环比">
                        <template  slot-scope="scope">
                            {{scope.row.perInterstitialTimesCircleRate==null?'0.00%':(scope.row.perInterstitialTimesCircleRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="ecpm">
                        <template  slot-scope="scope">
                            {{scope.row.interstitialEcpm==null?'0.00':scope.row.interstitialEcpm.toFixed(2)}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="环比">
                        <template  slot-scope="scope">
                            {{scope.row.interstitialEcpmCircleRate==null?'0.00%':(scope.row.interstitialEcpmCircleRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="arpu">
                        <template  slot-scope="scope">
                            {{scope.row.interstitialArpu==null?'0.00':scope.row.interstitialArpu.toFixed(3)}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="收入">
                        <template  slot-scope="scope">
                            {{scope.row.interstitialRevenue==null?'0.00':scope.row.interstitialRevenue.toFixed(2)}}
                        </template>
                    </el-table-column>
                </el-table-column>

                <el-table-column label="信息流" align="center">
                    <el-table-column  label="人均次数">
                        <template  slot-scope="scope">
                            {{scope.row.perFlowTimes==null?'0.00':scope.row.perFlowTimes.toFixed(2)}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="同比">
                        <template  slot-scope="scope">
                            {{scope.row.perFlowTimesSameRate==null?'0.00%':(scope.row.perFlowTimesSameRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="环比">
                        <template  slot-scope="scope">
                            {{scope.row.perFlowTimesCircleRate==null?'0.00%':(scope.row.perFlowTimesCircleRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="ecpm">
                        <template  slot-scope="scope">
                            {{scope.row.flowEcpm==null?'0.00':scope.row.flowEcpm.toFixed(2)}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="环比">
                        <template  slot-scope="scope">
                            {{scope.row.flowEcpmCircleRate==null?'0.00%':(scope.row.flowEcpmCircleRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="arpu">
                        <template  slot-scope="scope">
                            {{scope.row.flowArpu==null?'0.00':scope.row.flowArpu.toFixed(3)}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="收入">
                        <template  slot-scope="scope">
                            {{scope.row.flowRevenue==null?'0.00':scope.row.flowRevenue.toFixed(2)}}
                        </template>
                    </el-table-column>
                </el-table-column>

                <el-table-column label="开屏" align="center">
                    <el-table-column  label="人均次数">
                        <template  slot-scope="scope">
                            {{scope.row.perSplashTimes==null?'0.00':scope.row.perSplashTimes.toFixed(2)}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="同比">
                        <template  slot-scope="scope">
                            {{scope.row.perSplashTimesSameRate==null?'0.00%':(scope.row.perSplashTimesSameRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="环比">
                        <template  slot-scope="scope">
                            {{scope.row.perSplashTimesCircleRate==null?'0.00%':(scope.row.perSplashTimesCircleRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="ecpm">
                        <template  slot-scope="scope">
                            {{scope.row.splashEcpm==null?'0.00':scope.row.splashEcpm.toFixed(2)}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="环比">
                        <template  slot-scope="scope">
                            {{scope.row.splashEcpmCircleRate==null?'0.00%':(scope.row.splashEcpmCircleRate*100).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="arpu">
                        <template  slot-scope="scope">
                            {{scope.row.splashArpu==null?'0.00':scope.row.splashArpu.toFixed(3)}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="收入">
                        <template  slot-scope="scope">
                            {{scope.row.splashRevenue==null?'0.00':scope.row.splashRevenue.toFixed(2)}}
                        </template>
                    </el-table-column>
                </el-table-column>

                <el-table-column label="友盟留存" align="center">
                    <el-table-column  label="次留">
                        <template  slot-scope="scope">
                            {{scope.row.r1==null?'0.00%':(scope.row.r1).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="7留">
                        <template  slot-scope="scope">
                            {{scope.row.r7==null?'0.00%':(scope.row.r7).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="14留">
                        <template  slot-scope="scope">
                            {{scope.row.r14==null?'0.00%':(scope.row.r14).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                    <el-table-column  label="30留">
                        <template  slot-scope="scope">
                            {{scope.row.r30==null?'0.00%':(scope.row.r30).toFixed(2)+'%'}}
                        </template>
                    </el-table-column>
                </el-table-column>
            </el-table>
        </div>
        <div>
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.page"
                    :page-sizes="[10,20,50,100]"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next"
                    :total="page.totalElements">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {
        searchAdTypeIncomeRate,
        downloadData
    } from "@/http/outApi";
    import utils from '@/utils';
    export default {
        name: "AdTypeIncomeRateReport",
        data(){
            return{
                queryData:{
                    timeDate:['','']
                },
                page: {
                    size: 10,
                    page: 1,
                    totalElements: null
                },
                dataList:[],
                loading:true,
                pickerOptions: {
                    onPick: ({ maxDate, minDate }) => {
                        // 把选择的第一个日期赋值给一个变量。
                        this.choiceDate = minDate.getTime();
                        // 如何你选择了两个日期了，就把那个变量置空
                        if (maxDate) this.choiceDate = ''
                    },
                    disabledDate: time => {
                        // 如何选择了一个日期
                        if (this.choiceDate) {
                            console.log(time.getTime(),66,this.choiceDate);
                            // 7天的时间戳
                            const one = 13 * 24 * 3600 * 1000;
                            // 当前日期 - one = 7天之前
                            const minTime = this.choiceDate - one;
                            // 当前日期 + one = 7天之后
                            const maxTime = this.choiceDate + one;
                            return (
                                time.getTime() < minTime ||
                                time.getTime() > maxTime
                            )
                        }else{
                            return false
                        }
                    }
                }
            }
        },
        methods:{
            formatDate: function(column,format) {
                return utils.DateUtil.formatDate(column, format)
            },
            handleSizeChange(size) {
                this.page.size = size;
                this.query();
            },
            handleCurrentChange(page) {
                this.page.page = page;
                this.query();
            },
            query(){
                this.queryData.page = this.page.page;
                this.queryData.size = this.page.size;
                if (this.queryData.timeDate === null) {
                    this.queryData.timeDate = ['',''];
                }
                this.queryData.startDt = this.queryData.timeDate[0] ===''?null:this.queryData.timeDate[0];
                this.queryData.endDt = this.queryData.timeDate[1]===''?null:this.queryData.timeDate[1];
                this.loading = true;
                searchAdTypeIncomeRate(this.queryData).then(resp=>{
                    if (resp.data.status===0){
                        this.loading = false;
                        this.dataList=resp.data.info.list;
                        this.page.totalElements =resp.data.info.total;
                    }
                });
            },
            exportExcel(){
                let fileName = new Date().toLocaleString() + '收入分布占比日报.xlsx';
                downloadData(
                    '/report/exportAdTypesRate',
                    this.queryData,
                    fileName
                )
            }
        },
        created () {
            this.queryData.timeDate = [utils.TodayUtil.getWeekAgo(),utils.TodayUtil.getToday()];
            this.query();
        }
    }
</script>
sh
<style scoped>

</style>